module.exports = __webpack_public_path__ + "static/services-94522de6751465616de4d7d86feda7cc.jpg";